/*
  Collection grid pagination — infinite-scroll or load-more.

  Exposed on window so ms-collection-filters.liquid's MutationObserver
  can re-run it after Dawn's AJAX filter swap (which re-renders the
  pagination wrap inside the product grid container).
*/
window.msInitPagination = function () {
  const wrap = document.querySelector('[data-ms-pagination]');
  if (!wrap || wrap.dataset.msInitialized === 'true') return;
  wrap.dataset.msInitialized = 'true';
  const style = wrap.dataset.style;

  const fetchAndAppend = async () => {
    const nextUrl = wrap.dataset.nextUrl;
    if (!nextUrl) return;
    const sectionId = document.getElementById('product-grid')?.dataset.id;
    if (!sectionId) return;
    const url = nextUrl + (nextUrl.includes('?') ? '&' : '?')
      + 'section_id=' + encodeURIComponent(sectionId);
    const res = await fetch(url);
    if (!res.ok) return;
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const grid = document.getElementById('product-grid');
    const newItems = doc.querySelectorAll('#product-grid .grid__item');
    if (!grid || !newItems.length) return;
    newItems.forEach(item => {
      // Dawn's scroll-reveal sets opacity: 0.01 on these classes until a
      // separate observer reveals them. Appended items skip that observer,
      // so strip the classes to keep them visible.
      item.classList.remove('scroll-trigger', 'animate--slide-in');
      item.removeAttribute('data-cascade');
      item.style.removeProperty('--animation-order');
      grid.appendChild(item);
    });
    const newWrap = doc.querySelector('[data-ms-pagination]');
    if (newWrap && newWrap.dataset.nextUrl) {
      wrap.dataset.nextUrl = newWrap.dataset.nextUrl;
    } else {
      delete wrap.dataset.nextUrl;
    }
  };

  if (style === 'infinite_scroll') {
    const sentinel = wrap.querySelector('[data-ms-pagination-sentinel]');
    const indicator = wrap.querySelector('[data-ms-pagination-indicator]');
    const endMsg = wrap.querySelector('[data-ms-pagination-end]');
    if (!sentinel) return;

    wrap.dataset.msStatus = 'ready';

    let loading = false;
    const trigger = async () => {
      if (loading || !wrap.dataset.nextUrl) return;
      const rect = sentinel.getBoundingClientRect();
      if (rect.top - window.innerHeight > 600) return;
      loading = true;
      wrap.dataset.msStatus = 'loading';
      indicator && indicator.removeAttribute('hidden');
      try {
        await fetchAndAppend();
      } catch (err) {
        wrap.dataset.msStatus = 'error: ' + (err && err.message || err);
      } finally {
        loading = false;
        indicator && indicator.setAttribute('hidden', '');
        if (!wrap.dataset.nextUrl) {
          sentinel.remove();
          endMsg && endMsg.removeAttribute('hidden');
          window.removeEventListener('scroll', onScroll);
          wrap.dataset.msStatus = 'end';
        } else {
          wrap.dataset.msStatus = 'ready';
          // Re-check in case the sentinel is still in view after the append.
          requestAnimationFrame(trigger);
        }
      }
    };
    let scheduled = false;
    const onScroll = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; trigger(); });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    trigger();
  } else if (style === 'load_more') {
    const btn = wrap.querySelector('[data-ms-load-more]');
    const meta = wrap.querySelector('[data-ms-load-meta]');
    if (!btn) return;
    btn.addEventListener('click', async () => {
      if (!wrap.dataset.nextUrl) return;
      btn.disabled = true;
      const originalText = btn.textContent;
      btn.textContent = 'Loading…';
      try {
        await fetchAndAppend();
        const total = wrap.dataset.totalItems;
        const grid = document.getElementById('product-grid');
        const count = grid ? grid.querySelectorAll('.grid__item').length : 0;
        if (meta && total) {
          meta.innerHTML = 'Showing <strong>' + count + '</strong> of <strong>' + total + '</strong>';
        }
        if (!wrap.dataset.nextUrl) btn.remove();
      } finally {
        btn.disabled = false;
        btn.textContent = originalText;
      }
    });
  }
};
window.msInitPagination();
